import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { Eyebrow } from "@/components/Eyebrow";

export default function NotFound() {
  return (
    <Layout>
      <section className="max-w-2xl mx-auto px-5 sm:px-8 py-32 text-center" data-testid="not-found-page">
        <Eyebrow>404 · Off-route</Eyebrow>
        <h1 className="font-serif font-medium text-5xl text-ink mt-4 tracking-tight">
          This page took a different route.
        </h1>
        <p className="mt-5 text-ink-soft">
          Maybe it's at a different school now. Try the homepage, or send us a note.
        </p>
        <div className="mt-10 flex gap-3 justify-center">
          <Link
            to="/"
            className="bg-ivy hover:bg-ivy-light text-bone uppercase tracking-[0.18em] text-xs font-semibold py-4 px-7 transition-colors"
          >
            Home
          </Link>
          <Link
            to="/contact"
            className="border border-stone/50 hover:border-ink text-ink uppercase tracking-[0.18em] text-xs font-semibold py-4 px-6 transition-colors"
          >
            Contact
          </Link>
        </div>
      </section>
    </Layout>
  );
}
